import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadDiscountUsage } from './actions';
import UsageList from './usageList';
import { Panel } from 'react-bootstrap';

class Usage extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageSize } = this.props.pagination;

		this.loadData({ sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities(this.props.discount.id, { ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleListEvent(listPagination) {
		this.loadData({ ...listPagination });
	}

	render() {
		return <Panel>
			<Panel.Body>
				<UsageList onFetchData={this.handleListEvent} data={this.props.data} discount={this.props.discount} {...this.props.pagination} />
				</Panel.Body>
			</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	let discount = ownProps.discount;
	const {
		pagination,
		entities: { discountUsage }
	} = state;

	const discountUsagePagination = pagination.discountUsage.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		discount,
		data: discountUsagePagination.ids.map(id => discountUsage[id]),
		pagination: discountUsagePagination
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadDiscountUsage
})(Usage);